// Copyright (c) StrangeBee 2023

import { SortButton } from '@Atoms/Buttons';
import { SortDirections } from '@Hooks/useSort';
import { Space } from 'antd';
import React, { ReactElement } from 'react';
import { TitleSortableField } from './type';

type MultiFieldProps = {
    title: any[];
    onSortChange: (title: TitleSortableField, dir: SortDirections) => void;
    treatSortValue: (title: TitleSortableField) => SortDirections;
};

export const MultiField = ({ title, onSortChange, treatSortValue }: MultiFieldProps): ReactElement => {
    return (
        <Space size="middle">
            {title.reduce((acc, { hide = false, ...data }): ReactElement[] => {
                if (hide) {
                    return acc;
                }

                const comp =
                    data.sortField && !data.disableSort ? (
                        <SortButton
                            key={data.label}
                            label={data.label}
                            onSortChange={(newDirection: SortDirections): void => {
                                onSortChange({ label: data.label, sortField: data.sortField }, newDirection);
                            }}
                            value={treatSortValue({ label: data.label, sortField: data.sortField })}
                        />
                    ) : (
                        data.label
                    );
                return [...acc, comp];
            }, [] as ReactElement[])}
        </Space>
    );
};
